import React from 'react';

function CancellationRefunds() {
  return (
    <div className="min-h-screen bg-[#0B0F17] text-gray-100 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
          Cancellation and Refunds
        </h1>
        
        <div className="space-y-8 text-gray-400">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Cancellation Policy</h2>
            <p className="leading-relaxed">
              You may cancel your purchase at any time before scheduling your first interview. Cancellations after the first interview will not be eligible for a refund.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Refund Eligibility</h2>
            <p className="leading-relaxed">
              We offer a 14-day money-back guarantee for all new subscriptions. If you're not satisfied 
              with our service, you can request a full refund within 14 days of your initial purchase.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Refund Process</h2>
            <p className="leading-relaxed">
              To request a refund, contact our support team through the "Contact Us" page. Approved refunds 
              will be processed within 5-7 business days to your original payment method.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Technical Issues</h2>
            <p className="leading-relaxed">
              If a session is disrupted due to technical failures on our end, you may request a reschedule by contacting us through the “Contact Us” page. Our team will review the issue and determine eligibility for a free reschedule. We are not responsible for disruptions caused by user-side issues such as poor internet connection or device malfunctions.            
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">5. 	Usage Validity</h2>
            <p className="leading-relaxed">
              Unused interview sessions will remain available for use until 30 days from the time of purchase, after which they will no longer be valid.            
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default CancellationRefunds; 